/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type GoalSubject from '@linc-technologies/linced-common/models/goals/subject';
import type Milestone from '@linc-technologies/linced-common/models/milestones/milestone';
import type Page from '@linc-technologies/linced-common/models/posts/page';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: milestones.Expectation.
export default class Expectation extends Model {
  declare [Type]: 'milestones/expectation';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @belongsTo('posts/page', { async: true, inverse: null })
  declare pageId: AsyncBelongsTo<Page>;

  @alias('pageId')
  declare page: AsyncBelongsTo<Page>;

  @alias('page.id')
  declare page_id: string | null | undefined;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare goalSubjectId: AsyncBelongsTo<GoalSubject>;

  @alias('goalSubjectId')
  declare goalSubject: AsyncBelongsTo<GoalSubject>;

  @alias('goalSubject.id')
  declare goal_subject_id: string | null | undefined;

  @belongsTo('milestones/milestone', { async: true, inverse: null })
  declare milestoneId: AsyncBelongsTo<Milestone>;

  @alias('milestoneId')
  declare milestone: AsyncBelongsTo<Milestone>;

  @alias('milestone.id')
  declare milestone_id: string | null | undefined;

  @attr('number', { defaultValue: 0 })
  declare belowIndex: number;

  @attr('number', { defaultValue: 0 })
  declare atIndex: number;

  @attr('number', { defaultValue: 0 })
  declare aboveIndex: number;

  @attr('number', { defaultValue: 0 })
  declare wellAboveIndex: number;

  @attr('string', { defaultValue: '' })
  declare templateId: string;
}
